import React, { useEffect, useState } from 'react';
import { Wallet, DollarSign, PiggyBank, Shield, Archive } from 'lucide-react';
import { API_URL } from "../../components/config";
const TransactionTable = () => {
    const [transactions, setTransactions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_URL}/application_statistics/get_last_statistic`); // Replace with your actual API endpoint
                const result = await response.json();
                setTransactions(result.results);
            } catch (error) {
                console.error('Error fetching transactions:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="overflow-x-auto p-4">
            <table className="min-w-full bg-white border border-gray-200">
                <thead>
                    <tr className="bg-gray-200 text-gray-600">
                        <th className="py-3 px-4 text-left">Top Up ID</th>
                        <th className="py-3 px-4 text-left">Date</th>
                        <th className="py-3 px-4 text-left">Description</th>
                        <th className="py-3 px-4 text-left">Client Profile ID</th>
                        <th className="py-3 px-4 text-left">Vendor ID</th>
                        <th className="py-3 px-4 text-left">User Wallet Debit</th>
                        <th className="py-3 px-4 text-left">User Wallet Credit</th>
                        <th className="py-3 px-4 text-left">User Wallet Balance</th>
                        <th className="py-3 px-4 text-left">User Wallet Total Balance</th>
                        <th className="py-3 px-4 text-left">Revenue Wallet Balance</th>
                        <th className="py-3 px-4 text-left">Revenue Wallet Total Balance</th>
                        <th className="py-3 px-4 text-left">Escrow Total Balance</th>
                        <th className="py-3 px-4 text-left">Folio</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((transaction) => (
                        <tr key={transaction.top_up_id} className="hover:bg-gray-100">
                            <td className="border-t py-3 px-4">{transaction.top_up_id}</td>
                            <td className="border-t py-3 px-4">{transaction.date}</td>
                            <td className="border-t py-3 px-4">{transaction.description}</td>
                            <td className="border-t py-3 px-4">{transaction.client_profile_id}</td>
                            <td className="border-t py-3 px-4">{transaction.vendor_id || 'N/A'}</td>
                            <td className="border-t py-3 px-4">{transaction.user_wallet_debit}</td>
                            <td className="border-t py-3 px-4">{transaction.user_wallet_credit}</td>
                            <td className="border-t py-3 px-4">{transaction.user_wallet_balance}</td>
                            <td className="border-t py-3 px-4">{transaction.user_wallet_total_balance}</td>
                            <td className="border-t py-3 px-4">{transaction.revenue_wallet_balance}</td>
                            <td className="border-t py-3 px-4">{transaction.revenue_wallet_total_balance}</td>
                            <td className="border-t py-3 px-4">{transaction.escrow_total_balance}</td>
                            <td className="border-t py-3 px-4">{transaction.folio}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TransactionTable;